export { HAWKERS_REPORT_EN_US } from "./hawkers-report-en-us";
export { HAWKERS_REPORT_ES_ES } from "./hawkers-report-es-es";
export { HAWKERS_REPORT_ES_MX } from "./hawkers-report-es-mx";
export { HAWKERS_REPORT_FR_FR } from "./hawkers-report-fr-fr";
export { HAWKERS_REPORT_PT_BR } from "./hawkers-report-pt-br";
export type { HawkersReportTranslations } from "./hawkers-report-pt-br";
